$(document).ready(function () {
  toTopBind();
});

function toTopBind() {
  // console.log('toTopBind');
  var $scrollTop = $(window).scrollTop();

  if ($('#to_top').length > 0 && $(window).width() > 1034) {
    if ($scrollTop > 350) {
      $(window).on('scroll', hideToTop);
    } else {
      $(window).on('scroll', showToTop);
    }
  }

  //scroll up event
  $('body').on('click', '#to_top, a[href="#top"]', function () {
    $('body,html').stop().animate(
      {
        scrollTop: 0,
      },
      800
    );
    return false;
  });

  if (
    !$('body').hasClass('single-product') &&
    !$('body').hasClass('page-template-page-preserve-the-pit') &&
    !$('body').hasClass('page-template-template-thanksgrilling-2020') &&
    !$('body').hasClass('page-template-signature-flavors-page')
  ) {
    $('a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        var h_height = $('.header--global').height();

        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          $('html,body').animate(
            {
              scrollTop: target.offset().top - h_height,
            },
            1000
          );
          return false;
        }
      }
    });
  }
}

function showToTop() {
  // console.log('showToTop');
  var $scrollTop = $(window).scrollTop();
  if ($scrollTop > 350) {
    $('#to_top').stop(true, true).animate(
      {
        bottom: '30px',
      },
      350
    );

    $(window).off('scroll', showToTop);
    $(window).on('scroll', hideToTop);
  }
}

function hideToTop() {
  // console.log('hideToTop');
  var $scrollTop = $(window).scrollTop();
  if ($scrollTop < 350) {
    $('#to_top').stop(true, true).animate(
      {
        bottom: '-30px',
      },
      350
    );

    $(window).off('scroll', hideToTop);
    $(window).on('scroll', showToTop);
  }
}
